<template>
  <div class="ui_app">
    <header
      class="my-header"
      style="box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04); z-index: 1"
    >
      <div class="my-header-back" @click="close()"></div>
      <div class="my-header-title">基本资料</div>
    </header>

    <div class="ui_list">
      <div class="ui_list-item" v-if="!user.sap">
        <div class="ui_item-top my-flex-between ui_item-top-pb">
          <div>
            证件照
            <font>*</font>
          </div>
          <div class="my-flex" @click="toLogoAction()">
            <div
              :style="normalData.avatar ? 'color:#383838' : 'color:#9499AF'"
              v-text="normalData.avatar ? '已上传' : '未上传'"
            ></div>
            <img src="../../assets/moreDark.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item" @click="toUpIDCard(1)">
        <div class="ui_item-top my-flex-between ui_item-top-pb">
          <div>
            身份证照片(正面)
            <font>*</font>
          </div>
          <div class="my-flex">
            <div
              :style="
                normalData.id_card_front ? 'color:#383838' : 'color:#9499AF'
              "
              v-text="normalData.id_card_front ? '已上传' : '未上传'"
            ></div>
            <img src="../../assets/moreDark.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item" @click="toUpIDCard(2)">
        <div class="ui_item-top my-flex-between ui_item-top-pb">
          <div>
            身份证照片(反面)
            <font>*</font>
          </div>
          <div class="my-flex">
            <div
              :style="
                normalData.id_card_back ? 'color:#383838' : 'color:#9499AF'
              "
              v-text="normalData.id_card_back ? '已上传' : '未上传'"
            ></div>
            <img src="../../assets/moreDark.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            姓名
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom">
          <span
            v-text="normalData.name ? normalData.name : '无需填写'"
            v-if="backInfo.name || user.sap"
          ></span>
          <input
            type="text"
            name=""
            value=""
            v-model="normalData.name"
            placeholder="请输入您的真实姓名"
            v-else
          />
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            身份证号码
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom">
          <span
            v-if="backInfo.id_card_num || user.sap"
            v-text="
              normalData.id_card_num ? normalData.id_card_num : '无需填写'
            "
          ></span>
          <input
            style="text-transform: uppercase"
            type="text"
            v-model="normalData.id_card_num"
            placeholder="请输入您的身份证号"
            v-on:input="getCountAge()"
            v-else
          />
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            性别
            <font>*</font>
          </div>
        </div>
        <div class="ui_change my-flex">
          <div
            :class="
              normalData.gender == 1
                ? 'ui_change-item1 my-flex'
                : 'ui_change-item my-flex'
            "
            @click="tipClick(0, 0)"
          >
            <div
              :class="
                normalData.gender == 1
                  ? 'ui_change-dot-active'
                  : 'ui_change-dot'
              "
            ></div>
            男
          </div>
          <div
            :class="
              normalData.gender == 2
                ? 'ui_change-item1 my-flex'
                : 'ui_change-item my-flex'
            "
            @click="tipClick(0, 1)"
          >
            <div
              :class="
                normalData.gender == 2
                  ? 'ui_change-dot-active'
                  : 'ui_change-dot'
              "
            ></div>
            女
          </div>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            生日
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom" v-text="normalData.birthday"></div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            民族
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom">
          <!-- <span v-text="showNation" v-if="backInfo.nation||user.sap"></span> -->
          <span v-text="showNation" v-if="user.sap"></span>
          <select
            style="padding: 0; color: #383838"
            v-model="normalData.nation"
            v-else
          >
            <option :value="item.code" v-for="item in nation" :key="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            年龄
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom">
          <!-- <input type="number" pattern="\d*" v-model="normalData.age" placeholder="请输入您的年龄"> -->
          <span v-text="normalData.age" placeholder=""></span>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            身高
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom">
          <input
            type="number"
            pattern="\d*"
            v-model="normalData.height"
            placeholder="请输入您的身高（cm）"
          />
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>
            体重
            <font>*</font>
          </div>
        </div>
        <div class="ui_item-bottom">
          <input
            type="number"
            pattern="\d*"
            v-model="normalData.weight"
            placeholder="请输入您的体重（kg）"
          />
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>是否服从调配</div>
        </div>
        <div class="ui_change my-flex">
          <div
            :class="
              normalData.is_obey == 0
                ? 'ui_change-item1 my-flex'
                : 'ui_change-item my-flex'
            "
            @click="tipClick(1, 0)"
          >
            <div
              :class="
                normalData.is_obey == 0
                  ? 'ui_change-dot-active'
                  : 'ui_change-dot'
              "
            ></div>
            是
          </div>
          <div
            :class="
              normalData.is_obey == 1
                ? 'ui_change-item1 my-flex'
                : 'ui_change-item my-flex'
            "
            @click="tipClick(1, 1)"
          >
            <div
              :class="
                normalData.is_obey == 1
                  ? 'ui_change-dot-active'
                  : 'ui_change-dot'
              "
            ></div>
            否
          </div>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div class="ui_list-item">
        <div class="ui_item-top my-flex-between">
          <div>是否需要住宿</div>
        </div>
        <div class="ui_change my-flex">
          <div
            :class="
              normalData.is_stay == 0
                ? 'ui_change-item1 my-flex'
                : 'ui_change-item my-flex'
            "
            @click="tipClick(2, 0)"
          >
            <div
              :class="
                normalData.is_stay == 0
                  ? 'ui_change-dot-active'
                  : 'ui_change-dot'
              "
            ></div>
            是
          </div>
          <div
            :class="
              normalData.is_stay == 1
                ? 'ui_change-item1 my-flex'
                : 'ui_change-item my-flex'
            "
            @click="tipClick(2, 1)"
          >
            <div
              :class="
                normalData.is_stay == 1
                  ? 'ui_change-dot-active'
                  : 'ui_change-dot'
              "
            ></div>
            否
          </div>
        </div>
      </div>
      <div class="ui_list-border"></div>
      <div
        :class="infoChange ? 'ui_btn' : 'ui_btn'"
        @click="submit()"
        v-text="backInfo.id_card_num ? '更新' : '保存'"
      ></div>
      <input
        id="ui_file"
        ref="uiFile"
        type="file"
        accept="image/*"
        @change="fileSel"
      />
    </div>
    <eject
      :kzType="kzType"
      :showstate="kzShow"
      :msg="kzMsg"
      @toCancel="cancelFall"
      @took="okFall"
    ></eject>
  </div>
</template>
<style scoped>
@import "./useInfo.css";
</style>
<script>
// import myComress from "./imgCompress.js"; //这里注意自己的路径
import Vue from "vue";
import eject from "../../components/eject.vue";

export default {
  name: "userInfo",
  components: {
    eject,
  },
  data() {
    return {
      infoChange: false,
      user: "",
      normalData: {
        avatar: "",
        name: "",
        id_card_num: "",
        id_card_front: "",
        id_card_back: "",
        gender: 1,
        birthday: "未填写",
        age: "未填写",
        nation: "001",
        height: "",
        weight: "",
        is_obey: 0,
        is_stay: 0,
      },
      backInfo: {
        avatar: "",
        name: "",
        id_card_num: "",
        id_card_front: "",
        id_card_back: "",
        gender: "",
        birthday: "",
        age: "",
        nation: "",
        height: "",
        weight: "",
        is_obey: "",
        is_stay: "",
      }, //保存已上传的基本资料
      nation: "", //56民族数据
      upFileType: 0, //1头像，2身份证正面，3身份证反面

      kzType: 0, //弹框相关参数
      kzMsg: "",
      kzShow: false,

      idCardAc: "", //face back身份证上传的正反面
    };
  },
  mounted() {
    this.setUser();
    if (this.$nation) {
      this.nation = this.$nation;
    }
  },
  methods: {
    //提交基本资料
    submit: function () {
      if (!this.normalData.avatar) {
        this.toShowToast(1, 4, "请上传您的证件照");
      } else if (
        !this.normalData.id_card_front ||
        !this.normalData.id_card_back
      ) {
        this.toShowToast(1, 4, "请上传您的身份证");
      } else if (!this.normalData.id_card_num) {
        this.toShowToast(1, 4, "请填写您的身份证号码");
      } else if (!this.normalData.gender) {
        this.toShowToast(1, 4, "请选择您的性别");
      } else if (!this.normalData.nation) {
        this.toShowToast(1, 4, "请选择您的民族");
      } else if (!this.normalData.age || this.normalData.age == "未填写") {
        this.toShowToast(1, 4, "请选择您的年龄");
      } else if (
        !this.normalData.birthday ||
        this.normalData.birthday == "未填写"
      ) {
        this.toShowToast(1, 4, "请选择您的生日");
      } else if (!this.normalData.height) {
        this.toShowToast(1, 4, "请填写您的身高（cm）");
      } else if (!this.normalData.weight) {
        this.toShowToast(1, 4, "请填写您的体重（kg）");
      } else {
        this.submitChild();
      }
    },
    submitChild: function () {
      this.toShowToast(1, 1);
      let that = this;
      let data = {};
      for (let p in this.normalData) {
        if (this.normalData[p]) {
          data[p] = this.normalData[p];
        }
        if (p == "is_stay") {
          let config = {
            headers: {
              token: this.user.token,
            },
          };
          this.$http
            .post("/api/v1/user/updateBaseInfo", data, config)
            .then((res) => {
              that.toShowToast(0);
              let bDt = res.data;
              that.toShowToast(1, 4, bDt.msg);
              if (bDt.code == 1) {
                that.user.avatar = that.normalData.avatar;
                that.user.rate = 100;
                Vue.prototype.$user = that.user;
                setTimeout(function () {
                  that.$parent.pageBack();
                }, 1500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    //获取已上传基本资料数据
    getnormaldata: function () {
      let that = this;
      let config = {
        headers: {
          token: this.user.token,
        },
      };
      this.$http
        .post("/api/v1/user/getBaseInfo", {}, config)
        .then((res) => {
          let ret = res.data.data;
          if (ret.baseInfo) {
            for (var p in ret.baseInfo) {
              if (ret.baseInfo[p]) {
                that.normalData[p] = ret.baseInfo[p];
                that.backInfo[p] = ret.baseInfo[p];
                if (p == "nation") {
                  that.setNation(ret.baseInfo[p]);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancelFall() {
      this.kzShow = false;
    },
    okFall() {
      this.kzShow = false;
    },
    toShowToast(status, type, msg) {
      let that = this;
      //type 1加载中 2选择确认框 3确认框 4单提示1.5s后关闭
      if (status) {
        this.kzType = type;
        this.kzMsg = msg;
        this.kzShow = true;
      } else {
        this.kzShow = false;
        this.kzType = 0;
        this.kzMsg = "";
      }
      if (type == 4) {
        setTimeout(function () {
          that.toShowToast(0);
        }, 1500);
      }
    },
    setUser() {
      if (this.$user) {
        this.user = this.$user;
        this.getnormaldata();
      }
    },
    close() {
      this.$parent.pageBack();
    },
    //页面圆点点击监听
    tipClick: function (index, index1) {
      switch (index) {
        case 0:
          this.normalData.gender = index1 + 1;
          break;
        case 1:
          this.normalData.is_obey = index1;
          break;
        case 2:
          this.normalData.is_stay = index1;
          break;
        default:
      }
    },
    toUpIDCard(type) {
      //上传身份证 type 1正面，2反面
      if (type == 1) {
        this.idCardAc = "face";
        this.upFileType = 2;
      } else {
        this.idCardAc = "back";
        this.upFileType = 3;
      }
      this.$refs.uiFile.click();
    },
    toLogoAction() {
      //上传头像
      this.upFileType = 1;
      this.$refs.uiFile.click();
    },
    fileSel(e) {
      //文件选择
      let file = e.target.files[0];
      this.uploadImg(file);
    },
    async uploadImg(file) {
      this.toShowToast(1, 1);
      let that = this;
      let url = "";
      let formData = new FormData();
      formData.append("file", file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          token: this.user.token,
        },
      };
      if (this.upFileType == 1) {
        url = "/api/v1/common/upload";
      } else {
        url = "/api/v1/common/uploadIdCard";
        formData.append("type", this.idCardAc);
      }

      this.$http
        .post(url, formData, config)
        .then((res) => {
          //   console.log(res);
          that.toShowToast(0);
          let bDt = res.data;
          that.toShowToast(1, 4, bDt.msg);
          if (bDt.code == 1) {
            if (that.upFileType == 1) {
              that.normalData.avatar = bDt.data.url;
            } else if (that.upFileType == 2) {
              let data = bDt.data;
              that.normalData.birthday = data.birth;
              that.normalData.name = data.name;
              that.normalData.age = data.age;
              that.normalData.id_card_num = data.num;
              if (data.sex == "男") {
                that.normalData.gender = 1;
              } else {
                that.normalData.gender = 2;
              }
              that.normalData.id_card_front = data.url;
              that.getNationCode(data.nationality);
            } else {
              that.normalData.id_card_back = bDt.data.url;
            }
          }
        })
        .catch((error) => {
          this.listRequesting = false;
          console.log(error);
        });
    },
    //根据字符设置民族对应code
    getNationCode: function (val) {
      if (val) {
        for (var i = 0; i < this.nation.length; i++) {
          if (this.nation[i].name.indexOf(val + "族") > -1) {
            this.normalData.nation = this.nation[i].code;
          }
        }
      }
    },
    //设置民族显示
    setNation: function (val) {
      for (var i = 0; i < this.nation.length; i++) {
        if (val == this.nation[i].code) {
          this.showNation = this.nation[i].name;
          return;
        }
      }
    },
  },
};
</script>